"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _validate = _interopRequireDefault(require("validate.js"));
var _inputData = require("./data/input-data");
var _inputError = require("./data/input-error");
var _get = _interopRequireDefault(require("lodash/get"));
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var Input = /*#__PURE__*/function (_Component) {
  _inherits(Input, _Component);
  function Input(props) {
    var _this;
    _classCallCheck(this, Input);
    _this = _callSuper(this, Input, [props]);
    var _this$props$inputFiel = _this.props.inputFieldName,
      inputFieldName = _this$props$inputFiel === void 0 ? '' : _this$props$inputFiel;
    var _InputData$inputField = _inputData.InputData[inputFieldName],
      values = _InputData$inputField.values,
      error = _InputData$inputField.error;
    _this.state = {
      error: error,
      inputColSize: null,
      isValid: false,
      values: values
    };
    _this.clearValue = _this.clearValue.bind(_assertThisInitialized(_this));
    _this.isValid = _this.isValid.bind(_assertThisInitialized(_this));
    _this.getValue = _this.getValue.bind(_assertThisInitialized(_this));
    _this.validateCheckbox = _this.validateCheckbox.bind(_assertThisInitialized(_this));
    _this.inputErrorFn = _this.inputErrorFn.bind(_assertThisInitialized(_this));
    _this.optionalState = _this.optionalState.bind(_assertThisInitialized(_this));
    _this.validState = _this.validState.bind(_assertThisInitialized(_this));
    _this.invalidState = _this.invalidState.bind(_assertThisInitialized(_this));
    _this.invalidCbState = _this.invalidCbState.bind(_assertThisInitialized(_this));
    _this.checkForHelperText = _this.checkForHelperText.bind(_assertThisInitialized(_this));
    _this.checkForErrorMsg = _this.checkForErrorMsg.bind(_assertThisInitialized(_this));
    _this.adjustInputSize = _this.adjustInputSize.bind(_assertThisInitialized(_this));
    _this.checkForLabel = _this.checkForLabel.bind(_assertThisInitialized(_this));
    _this.checkForIcon = _this.checkForIcon.bind(_assertThisInitialized(_this));
    _this.checkInputType = _this.checkInputType.bind(_assertThisInitialized(_this));
    _this.checkForAddOn = _this.checkForAddOn.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.instantCheckForError) {
        this.isValid();
      }
    }

    // TODO: Improve for all cases, not just standard input
  }, {
    key: "clearValue",
    value: function clearValue() {
      var input = this.refs.inputField;
      if (input.value) {
        input.value = input.defaultVal || '';
      }
      this.optionalState();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var ignoreValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var errorFree = true;
      var inputFieldName = this.props.inputFieldName;
      var errorData = _inputError.InputError[inputFieldName].error;
      var constraints = errorData.constraints;
      var customConstraints = this.props.customConstraints;
      var input = this.refs.inputField;
      if ('checkbox' === input.type) {
        this.validateCheckbox();
      }
      if (customConstraints) {
        _validate.default.validators.custom = customConstraints;
      }
      var val = input.value;
      var isError = _validate.default.single(val, !ignoreValidation ? constraints : {});
      var optional = this.props.optional;
      if (!this.props.validFn) {
        this.inputErrorFn(isError, inputFieldName, val);
      } else {
        this.props.validFn();
      }
      if (isError && (!optional || val)) {
        errorFree = false;
      }
      return errorFree;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var input = this.refs.inputField;
      var val = input.value;
      return val;
    }
  }, {
    key: "validateCheckbox",
    value: function validateCheckbox() {
      var checkbox = this.refs.inputField;
      var checked = checkbox.checked;
      if (checked) {
        checkbox.value = true;
      } else {
        checkbox.value = '';
      }
    }
  }, {
    key: "inputErrorFn",
    value: function inputErrorFn(isError, inputFieldName, val) {
      var _this2 = this;
      var errorData = _inputError.InputError[inputFieldName].error;
      var optional = this.props.optional;
      if (isError) {
        if (optional && !val) {
          // the error msg that comes back for an optional field that is blank
          // is a string that says "optional", since it is optional this field
          // will return to its default UI and set isValid to true
          this.optionalState(errorData);
        } else {
          // will change UI of input field to an error state and
          // set isValid to false
          this.invalidState(errorData, isError);
        }
      } else {
        if (this.props.actionFn) {
          var user = {};
          var value = this.refs.inputField.value;
          if ('checkbox' === this.refs.inputField.type) {
            value = this.refs.inputField.checked;
          }
          user[this.props.elementID] = value;
          this.props.actionFn(user, function () {
            var _this2$props;
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            (_this2$props = _this2.props).actionCb.apply(_this2$props, [errorData, _this2.validState, _this2.invalidCbState].concat(args));
            // set state to isValid to true or false depending on
            // response of callback
            // if error will output error msg and display error state UI
          });
        } else {
          this.validState(errorData);
        }
      }
    }
  }, {
    key: "optionalState",
    value: function optionalState() {
      var errorObj = {};
      errorObj.inputBorder = null;
      errorObj.errorMsg = null;
      this.setState({
        isValid: true
      });
      this.setState({
        error: errorObj
      });
    }
  }, {
    key: "validState",
    value: function validState(errorData) {
      var errorObj = {};
      errorObj.inputBorder = null;
      errorObj.errorMsg = null;
      this.setState({
        isValid: true
      });
      this.setState({
        error: errorObj
      });
    }
  }, {
    key: "invalidState",
    value: function invalidState(errorData, isError) {
      var errorObj = {};
      errorObj.inputBorder = errorData.inputBorder;
      errorObj.errorMsg = isError[0];
      this.setState({
        isValid: false
      });
      this.setState({
        error: errorObj
      });
    }
  }, {
    key: "invalidCbState",
    value: function invalidCbState(errorData) {
      var errorObj = {};
      errorObj.inputBorder = errorData.inputBorder;
      this.setState({
        isValid: false
      });
      this.setState({
        error: errorObj
      });
    }
  }, {
    key: "checkForHelperText",
    value: function checkForHelperText(value) {
      var helperText = this.props.helperText || value.helper_text;
      if (helperText) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "help-block text-left info-text"
        }, helperText);
      }
    }
  }, {
    key: "checkForErrorMsg",
    value: function checkForErrorMsg(errors) {
      if (errors.errorMsg) {
        var _this$props = this.props,
          errorMessage = _this$props.errorMessage,
          intl = _this$props.intl;

        // use custom error message if defined
        if (errorMessage) {
          this.state.error.errorMsg = errorMessage;
        }
        var intlError = (0, _get.default)(this.state, 'error.errorMsg.id') ? intl.formatMessage(this.state.error.errorMsg) : this.state.error.errorMsg;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "help-block inline-help text-danger text-left"
        }, intlError);
      }
    }
  }, {
    key: "adjustInputSize",
    value: function adjustInputSize(labelSize) {
      var splitCols = labelSize.split('-');
      var colDifference = 12 - splitCols[2];
      if (0 === colDifference) {
        return;
      }
      var inputColSize = "".concat(splitCols[0], "-").concat(splitCols[1], "-").concat(colDifference);
      this.setState({
        inputColSize: inputColSize
      });
    }
  }, {
    key: "checkForLabel",
    value: function checkForLabel(value) {
      var _this$props2 = this.props,
        labelSize = _this$props2.labelSize,
        customLabel = _this$props2.customLabel;
      if (labelSize) {
        this.adjustInputSize(labelSize);
        return /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: value.id,
          className: "".concat(labelSize, " control-label text-left")
        }, this.props.label || value.label);
      }
      if (customLabel) {
        return customLabel;
      }
    }
  }, {
    key: "checkForIcon",
    value: function checkForIcon() {
      var icon = '';
      var caret = 'select' === (0, _get.default)(this.state, 'values.type') ? /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: 11,
          top: '3px',
          position: 'relative',
          marginLeft: '6px',
          marginRight: '4px'
        },
        className: "icon-arrow-nav"
      }) : '';
      if (!this.props.optional && !this.props.hideRequired) {
        icon = /*#__PURE__*/_react.default.createElement("span", {
          className: "required"
        }, "*");
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "form-control-feedback"
      }, icon, caret);
    }
  }, {
    key: "checkInputType",
    value: function checkInputType(value, errors) {
      var _this3 = this;
      var _this$props3 = this.props,
        dataAttributes = _this$props3.dataAttributes,
        intl = _this$props3.intl,
        _this$props3$ignoreTe = _this$props3.ignoreTextAreaBlurValidation,
        ignoreTextAreaBlurValidation = _this$props3$ignoreTe === void 0 ? false : _this$props3$ignoreTe;
      var props = this.props;
      var elementID = props.elementID || value.id;
      var valuePlaceholder = (0, _get.default)(value, 'placeholder.id') ? intl.formatMessage(value.placeholder) : value.placeholder;
      if ('textarea' === value.type) {
        return /*#__PURE__*/_react.default.createElement("textarea", _extends({}, dataAttributes, {
          maxLength: value.maxLength,
          ref: "inputField",
          className: "form-textarea form-control rr-block ".concat(errors.inputBorder || ''),
          id: elementID,
          placeholder: props.placeholder || valuePlaceholder,
          onBlur: function onBlur() {
            return _this3.isValid(ignoreTextAreaBlurValidation);
          },
          defaultValue: props.defaultVal,
          disabled: props.disabled
        }));
      }
      if ('checkbox' === value.type) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "CheckboxField custom-control custom-checkbox"
        }, /*#__PURE__*/_react.default.createElement("input", _extends({}, dataAttributes, {
          ref: "inputField",
          id: elementID,
          type: "checkbox",
          onChange: this.isValid,
          disabled: props.disabled,
          defaultChecked: props.defaultVal,
          className: "custom-control-input",
          name: props.name || elementID || ''
        })), /*#__PURE__*/_react.default.createElement("label", {
          className: "custom-control-label flex",
          htmlFor: elementID
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "checkbox-ui"
        }), value.label));
      }
      if ('select' === value.type) {
        var options = props.options,
          preSelect = props.preSelect,
          defaultText = props.defaultText;
        var color = preSelect ? '' : '#CED2DA';
        var onSelect = function onSelect(e) {
          var event = e;
          var colorAttribute = (0, _get.default)(event, 'currentTarget.style.color');
          if (colorAttribute) event.currentTarget.style.color = '#343840';
        };
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("select", {
          name: props.name || elementID || '',
          onChange: onSelect,
          onBlur: this.isValid,
          defaultValue: preSelect,
          style: {
            color: color
          },
          id: elementID,
          ref: "inputField",
          className: "form-control ".concat(errors.inputBorder || '')
        }, /*#__PURE__*/_react.default.createElement("option", {
          className: "select-default-text",
          value: "",
          disabled: true,
          selected: true
        }, defaultText || 'Select'), options.map(function (option) {
          var val = option.val,
            text = option.text;
          var info = {
            value: val
          };
          return /*#__PURE__*/_react.default.createElement("option", info, text || value);
        })));
      }
      return /*#__PURE__*/_react.default.createElement("input", _extends({}, dataAttributes, {
        min: this.props.min,
        max: this.props.max,
        maxLength: value.maxLength,
        ref: "inputField",
        name: props.name || elementID || '',
        type: value.type || 'text',
        className: "form-control rr-block ".concat(errors.inputBorder || ''),
        id: this.props.elementID || value.id,
        placeholder: this.props.placeholder || valuePlaceholder,
        onBlur: this.isValid,
        onChange: this.onChange,
        defaultValue: this.props.defaultVal || '',
        value: this.props.setVal ? this.props.setVal : undefined,
        disabled: this.props.disabled
      }));
    }
  }, {
    key: "checkForAddOn",
    value: function checkForAddOn(value, errors) {
      var addOn = this.props.addOn;
      if (addOn) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "input-group"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "input-group-addon"
        }, addOn), this.checkInputType(value, errors));
      }
      return this.checkInputType(value, errors);
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.values;
      var errors = this.state.error;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(this.props.colSize, {
          'col-xs-12': this.props.useBootstrapGrid && !this.props.colSize
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group has-feedback",
        style: this.props.useBootstrapGrid ? {} : {
          marginRight: 0,
          marginLeft: 0
        }
      }, this.checkForLabel(value), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('relative', this.props.inputColSize, {
          'col-xs-12': this.props.useBootstrapGrid && !this.props.inputColSize
        })
      }, this.checkForAddOn(value, errors), this.checkForIcon(errors), this.checkForErrorMsg(errors), this.checkForHelperText(value))));
    }
  }]);
  return Input;
}(_react.Component);
var InputField = exports.InputField = (0, _reactIntl.injectIntl)(Input, {
  withRef: true,
  forwardRef: true
});
Input.defaultProps = {
  optional: true,
  dataAttributes: {},
  disabled: false,
  useBootstrapGrid: true
};
Input.propTypes = {
  elementID: _propTypes.default.string,
  labelSize: _propTypes.default.string,
  // renders Size
  label: _propTypes.default.string,
  // renders label text from Form data
  colSize: _propTypes.default.string,
  optional: _propTypes.default.bool,
  // determines whether input is optional
  hideRequired: _propTypes.default.bool,
  // determines whether required is shown
  dataAttributes: _propTypes.default.object,
  // attributes for the input i.e. { data-stripe: 'bank-account'}
  inputFieldName: _propTypes.default.oneOf(['email', 'password', 'terms_of_service', 'first_name', 'last_name', 'address1', 'address2', 'city', 'state', 'zipcode', 'organization', 'mobile_phone', 'job_title', 'verification_code', 'login_pw', 'required_textbox_response', 'review_response', 'msg_host', 'flex_time', 'attendees', 'cardholders_name', 'cardnumber', 'month', 'year', 'day', 'cvv', 'default_input', 'default_input_number', 'default_textarea', 'account_number', 'routing_number', 'hidden_country_code', 'hidden_currency_code', 'account_holder', 'hidden_account_type', 'tax_id', 'business_name', 'last_4', 'board_name', 'board_description', 'activity', 'activity_date', 'location', 'meta_email', 'personal_message', 'concierge_budget', 'other_concierge_items', 'concierge_details', 'comment', 'other_how_did_you_hear', 'how_did_you_hear', 'block_day_title', 'csrf_token_input', 'transit_number', 'institution_number', 'account_number_ca', 'hidden_routing_number', 'account_number_uk', 'sort_code', 'all_day', 'bsb_number', 'account_number_au', 'iban_number', 'custom_offer_subtotal']).isRequired,
  // keys in input-data.js
  validFn: _propTypes.default.func,
  actionFn: _propTypes.default.func,
  actionCb: _propTypes.default.func,
  defaultVal: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  helperText: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  customConstraints: _propTypes.default.func,
  onChange: _propTypes.default.func,
  instantCheckForError: _propTypes.default.bool,
  ignoreTextAreaBlurValidation: _propTypes.default.bool,
  useBootstrapGrid: _propTypes.default.bool
};